module.exports = __webpack_public_path__ + "static/media/19.70940edc.svg";